export default __webpack_public_path__ + "static/media/kick.d7a1209b.wav";